import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SupabaseClientService } from './db/supabase-client';
import { Agent } from '@models/agent.types';

@Injectable({ providedIn: 'root' })
export class AgentsService {

  constructor(private supabaseClient: SupabaseClientService) {}

  /**
   * List all agents
   */
  list(): Observable<Agent[]> {
    return from(
      (async () => {
        const { data, error } = await this.supabaseClient.client
          .from('agents_with_status')
          .select('*')
          .order('name', { ascending: true });

        if (error) {
          console.error('AgentsService: Database error:', error);
          throw error;
        }
        
        return (data as Agent[]) ?? [];
      })()
    ).pipe(
      catchError((error) => {
        console.error('Failed to load agents:', error);
        return throwError(() => error);
      })
    );
  }
}

